import Model from '../../Model/File/WIG';
import Track from '../Graph/Bar';

export default Track.extend({
  model  : Model,
  name   : 'wig',
  height : 100,
});
